import { render } from "./GoCard.vue?vue&type=template&id=2aa3c74e&scoped=true"
import script from "./GoCard.vue?vue&type=script&lang=js"
export * from "./GoCard.vue?vue&type=script&lang=js"

import "./GoCard.vue?vue&type=style&index=0&id=2aa3c74e&scoped=true&lang=css"

import exportComponent from "/Users/home/Documents/kevin/ftd_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2aa3c74e"]])

export default __exports__